import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState, useEffect } from "react";
import { backend_url } from "./constants";
import { useAuth } from "./auth";
import Tooltip from "./components/Tooltip";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loginWithAccessToken } = useAuth();
  const [errored, setErrored] = useState(false);
  async function handleLogin(email, password) {
    const res = await fetch(backend_url + "/api/login/", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    if(res.status==200){
      const data = await res.json();
      loginWithAccessToken(data.access);
    }
    else{
      setErrored(true);
    }
  }
  return (
    <div className="login-background">
      <Container style={{ paddingTop: "35vh" }}>
        <Row style={{ justifyContent: "space-around" }}>
          <Col sm={4} className="justify-content-md-center">
            {[
              <Tooltip>
                {
                  <div>
                    <span className="material-symbols-rounded">schedule</span>{" "}
                    Closed Beta has begun. Contact us to join.
                  </div>
                }
              </Tooltip>,
              <div>
                <img src={`${process.env.PUBLIC_URL}/Logo.png`} style={{width: "20rem", paddingBottom: "15px"}} alt="ToxDT"></img>
                {/* <h1 className="dt-header-dark">Toxicological</h1>
                <h1 className="dt-header"> Digital Twin</h1> */}
              </div>,
              <div className="description-text">
                Predict chemical toxicity with our AI-powered rodent digital
                twin. Optimize experimental design, estimate PODs, and evaluate
                endpoint sensitivites using our state of the art simulations.
              </div>,
            ]}
          </Col>
          <Col sm={5} className="justify-content-md-center">
            <div className="floating-modal">
              <b style={{ fontSize: "large" }}>System Access</b>
              <div className="description-text" style={{ fontSize: "small" }}>
                ToxDT is currently in closed Beta.{" "}
                <a href="mailto:help@dreamtechllc.com">Contact us</a> if you're
                interested in joining the Beta.
              </div>
              <Form>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>
                    <b>Email address</b>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label>
                    <b>Password</b>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Group>
                {
                  errored ?
                  <div className="login-error">Couldn't log you in with those credentials</div>
                  : null
                }
                <Button
                  onClick={(e) => {
                    handleLogin(email, password);
                    e.preventDefault();
                  }}
                  disabled={!password | !email}
                  className="dt-button"
                  variant="primary"
                  type="submit"
                  style={{ width: "100%" }}
                >
                  Login to Dashboard
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
        <Row
          style={{
            justifyContent: "center",
            marginTop: "10vh",
            textAlign: "center",
          }}
        >
          <div className="dreamtech-container">
            A product of
            <img
              src={`${process.env.PUBLIC_URL}/DreamtechLogo.png`}
              className="login-logo"
              alt="DREAM Tech Logo"
            ></img>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
